// extracted by mini-css-extract-plugin
module.exports = {"verticalArrows":"_28r_k","navigationArrows":"_3LP2j","up":"IJNDp","down":"_1yzIC","left":"TBdPs","right":"cBcds","resetButton":"_15Dl8"};